import { normalizeId } from './ids';
export const getCommunityId = (community) => normalizeId(community);

export const getCommunityDashboardPath = (community) => {
  const communityId = getCommunityId(community);
  return communityId ? `/community/${communityId}/dashboard` : '';
};

const getTournamentAdminId = normalizeId;

export const getTournamentAdminDashboardPath = (community, tournamentAdmin) => {
  const communityId = getCommunityId(community);
  const tournamentAdminId = getTournamentAdminId(tournamentAdmin);

  if (!communityId || !tournamentAdminId) return '';

  return `/community/${communityId}/tournament-admin/${tournamentAdminId}/tournaments`;
};

export const getPlayerManagerDashboardPath = (community, playerManager) => {
  const communityId = getCommunityId(community);
  const playerManagerId = getTournamentAdminId(playerManager);

  if (!communityId || !playerManagerId) return '';

  return `/community/${communityId}/player-manager/${playerManagerId}/tournaments`;
};

export const getMatchManagerDashboardPath = (community, matchManager) => {
  const communityId = getCommunityId(community);
  const matchManagerId = getTournamentAdminId(matchManager);

  if (!communityId || !matchManagerId) return '';

  return `/community/${communityId}/match-manager/${matchManagerId}/tournaments`;
};

const getManagerId = normalizeId;

export const getAuctionManagerPath = (community, auctionManager, tournament) => {
  const communityId = getCommunityId(community);
  const auctionManagerId = getManagerId(auctionManager);
  const tournamentId = getManagerId(tournament);

  if (!communityId || !auctionManagerId || !tournamentId) return '';

  return `/community/${communityId}/auction-manager/${auctionManagerId}/tournaments/${tournamentId}`;
};
